import { castToOption } from 'src/helpers';

export enum CanadaProvinceOrTerritory {
  // Provinces
  Alberta = 'AB',
  BritishColumbia = 'BC',
  Manitoba = 'MB',
  NewBrunswick = 'NB',
  NewfoundlandAndLabrador = 'NL',
  NovaScotia = 'NS',
  Ontario = 'ON',
  PrinceEdwardIsland = 'PE',
  Quebec = 'QC',
  Saskatchewan = 'SL',

  // Territories
  NorthwestTerritories = 'NT',
  Nunavut = 'NU',
  Yukon = 'YT',
}

export const CANADA_PROVINCE_OR_TERRITORY_NAME: Record<CanadaProvinceOrTerritory, string> = {
  [CanadaProvinceOrTerritory.Alberta]: 'Alberta',
  [CanadaProvinceOrTerritory.BritishColumbia]: 'British Columbia',
  [CanadaProvinceOrTerritory.Manitoba]: 'Manitoba',
  [CanadaProvinceOrTerritory.NewBrunswick]: 'New Brunswick',
  [CanadaProvinceOrTerritory.NewfoundlandAndLabrador]: 'Newfoundland and Labrador',
  [CanadaProvinceOrTerritory.NovaScotia]: 'Nova Scotia',
  [CanadaProvinceOrTerritory.Ontario]: 'Ontario',
  [CanadaProvinceOrTerritory.PrinceEdwardIsland]: 'Prince Edward Island',
  [CanadaProvinceOrTerritory.Quebec]: 'Quebec',
  [CanadaProvinceOrTerritory.Saskatchewan]: 'Saskatchewan',

  [CanadaProvinceOrTerritory.NorthwestTerritories]: 'Northwest Territories',
  [CanadaProvinceOrTerritory.Nunavut]: 'Nunavut',
  [CanadaProvinceOrTerritory.Yukon]: 'Yukon',
};

export const CANADA_STATE_OPTIONS = castToOption(CanadaProvinceOrTerritory, CANADA_PROVINCE_OR_TERRITORY_NAME);
